import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

// The photos check uploads several photos AND waits for the AI verdict, which the default
// 15s axios timeout would cut short. The backend gives up on its own side before 30s.
const PHOTOS_CHECK_TIMEOUT_MS = 40_000;

class PlanSalesService {
  getPlans() {
    return securedAxiosInstance.get("/plan_sales", {
      params: {
        includes: [
          "scheduled_cancellation",
          "plan_sale_product",
          "plan_sale_contract",
          "plan_sale_contract.plan_sale_coverages",
          "contract_updates",
          "formula_change_letter",
        ],
      },
    });
  }

  getPlan(planSaleFriendlyId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleFriendlyId}`, {
      params: {
        includes: [
          "scheduled_cancellation",
          "plan_sale_product",
          "plan_sale_contract",
          "plan_sale_contract.plan_sale_coverages",
          "claims",
          "claims.claim_product",
          "formula_change_letter",
        ],
      },
    });
  }

  cancelPlan(planSaleFriendlyId, params) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleFriendlyId}/cancel`, toSnakeCase(params));
  }

  scheduleCancellation(params) {
    return securedAxiosInstance.post("/scheduled_cancellations", toSnakeCase(params));
  }

  deleteProductItem(planSaleId, productItemId) {
    return securedAxiosInstance.delete(`/plan_sales/${planSaleId}/product/composed_product_items/${productItemId}`);
  }

  // Step 1 of a product registration: uploads the photos, runs the AI check, and returns
  // the verdict along with the signed token step 2 requires.
  checkProductItemPhotos(planSaleId, formData) {
    return securedAxiosInstance.post(`/plan_sales/${planSaleId}/product/photos_checks`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: PHOTOS_CHECK_TIMEOUT_MS,
    });
  }

  // Step 2: the photos are already uploaded, so only their signed ids travel here.
  addProductItem(planSaleId, params) {
    return securedAxiosInstance.post(`/plan_sales/${planSaleId}/product/composed_product_items`, toSnakeCase(params));
  }

  updateProductItem(planSaleId, productItemId, params) {
    return securedAxiosInstance.put(
      `/plan_sales/${planSaleId}/product/composed_product_items/${productItemId}`,
      toSnakeCase(params),
    );
  }

  getPlanMembershipAgreement(planSaleFriendlyId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleFriendlyId}/membership_agreement`);
  }

  getPaymentMethod(planSaleId) {
    return securedAxiosInstance.get(`/customer/payment_methods/${planSaleId}`);
  }

  getPlanSepaMandate(planSaleFriendlyId) {
    return securedAxiosInstance.get(`/plan_sales/${planSaleFriendlyId}/sepa_mandate`);
  }

  getPaymentMethods() {
    return securedAxiosInstance.get("/customer/payment_methods");
  }

  getUpdatePaymentMethodLink(planSaleId) {
    return securedAxiosInstance.get(`/customer/payment_methods/update_link?plan_sale_id=${planSaleId}`);
  }

  declareProductExchange(friendlyId, params) {
    return securedAxiosInstance.put(`/plan_sales/${friendlyId}/exchange_product`, toSnakeCase(params));
  }
}

export default new PlanSalesService();
